import { applyFilters, doRequest } from "./helpers";

export default class CustomTableRowService {
  static async list(slug, filters = null) {
    let path = `/custom_tables/${slug}/rows`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(slug, rowId, { include_deleted } = {}) {
    let path = `/custom_tables/${slug}/rows/${rowId}`;
    if (include_deleted) {
      path += "?include_deleted=true";
    }
    return doRequest("GET", path);
  }

  static async getRowsForFilters(slug, filters = null) {
    let path = `/custom_tables/${slug}/rows/for_filters`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getListValuesForFilters(slug, fieldId, filters = null) {
    let path = `/custom_tables/${slug}/columns/${fieldId}/values/for_filters`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async create(slug, data) {
    return doRequest("POST", `/custom_tables/${slug}/rows`, { data });
  }

  static async update(slug, rowId, data) {
    return doRequest("PUT", `/custom_tables/${slug}/rows/${rowId}`, { data });
  }

  static async delete(slug, rowId) {
    return doRequest("DELETE", `/custom_tables/${slug}/rows/${rowId}`);
  }

  static async bulkDelete(slug, ids) {
    return doRequest("DELETE", `/custom_tables/${slug}/rows`, {
      data: { ids },
    });
  }
}
